import React from "react";
import { useSelector } from "react-redux";
import moment from "moment-timezone";
import empty from "../../../../assets/images/empty_history.png";

const TrackingHistory = ({ history }) => {
  history = typeof history === "string" ? JSON.parse(history) : history;
  history = history
    ? history.filter(
        ({ message, date_time }) => message?.length || date_time?.length
      )
    : [];
  const {
    general: { dateFormat, timeFormat },
    time_zone,
  } = useSelector((state) => state.settings);
  const { tracking_history } = useSelector((state) => state.i18n);

  return (
    <div className="omg-special-tracking-history">
      <div className="omg-section omg-special-tracking-history-section">
        <div className="omg-section__title">
          {tracking_history.shipment_history}
        </div>
        <div className="omg-section__content">
          <div className="omg-section">
            <div className="omg-section__content">
              <div className="list-logs">
                {history?.length ? (
                  history?.map((item, index) => (
                    <div
                      key={index}
                      className="log-item vertical-progress-node"
                    >
                      <div className="omg-time">
                        <div className="omg-time__major">
                          {moment(item.date_time).format(dateFormat)}
                        </div>
                        <div className="omg-time__minor">
                          {moment(item.date_time).format(timeFormat)}
                        </div>
                      </div>
                      <span className="log-item-history">{item?.message}</span>
                    </div>
                  ))
                ) : (
                  <div className="text-center">
                    <img src={empty} width="150" alt="..." />
                    <p
                      style={{ fontSize: 15, color: "#666", marginTop: "10px" }}
                    >
                      No shipment history
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrackingHistory;
